export const UPDATE_UPLOAD_VIDEO_LIST = 'UPDATE_UPLOAD_VIDEO_LIST';
export const UPDATE_SHOW_VIDEO_UPLOAD = 'UPDATE_SHOW_VIDEO_UPLOAD';
